export default {
  noActiveCalls: 'Aucun appel actif',
};
